import { useState, useCallback, useEffect, useRef } from 'react'
import { isArray } from 'lodash'
import axios from 'assets/js/axios'
import { getToken } from 'assets/js/auth'

export default function useEntity(
  route,
  id,
  lazy = false,
  key = 'id',
  asSuperuser = true,
  extraValue,
  extraKey
) {
  const unmonted = useRef(false)
  const [entity, setEntity] = useState(null)

  const get1 = useCallback(
    (keyValue, keyName, asSuperuser, extraValue, extraKey) => {
      const accessToken = getToken()
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      return extraKey
        ? axios
            .get(`${route}`, {
              headers,
              params: {
                [`${keyName}`]: `${keyValue}`,
                asSuperuser,
                [`${extraKey}`]: `${extraValue}`
              }
            })
            .then(response => response.data)
        : axios
            .get(`${route}`, {
              headers,
              params: {
                [`${keyName}`]: `${keyValue}`,
                asSuperuser
              }
            })
            .then(response => response.data)
    },
    [route]
  )

  const refresh = useCallback(async () => {
    const response = await get1(id, key, asSuperuser, extraValue, extraKey)
    if (!unmonted.current) {
      if (isArray(response)) {
        setEntity(response[0])
      } else {
        setEntity(response)
      }
    }
  }, [asSuperuser, extraKey, extraValue, get1, id, key])

  useEffect(() => {
    if (!lazy && !!id) refresh(id, key)

    return () => {
      unmonted.current = true
    }
  }, [refresh, id, lazy, key]) // eslint-disable-line

  return [entity, get1]
}
